import { Component, OnDestroy, OnInit } from '@angular/core';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Subscription } from 'rxjs';

import { CourtBookingInfoModel } from '@bayclubs/court-booking-employee-api';
import { CoreFacade } from '@core/core.module';
import { CourtEventNoteSaveLauncherService, SaveCourtEventNoteSuccessAction } from '@court-event-note-save/court-event-note-save.module';

import { CancelCourtEventLauncherService } from '@court-event-modals/court-event-modals.module';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CourtEventInfoFacade } from '../../+store/court-event-info.facade';

@Component({
    selector: 'app-court-booking-info-details',
    templateUrl: './court-booking-info-details.component.html',
    styleUrls: ['./court-booking-info-details.component.scss'],
    standalone: false
})
export class CourtBookingInfoDetailsComponent implements OnInit, OnDestroy {
    spinner$ = this.courtEventInfoFacade.spinner$;
    courtBookingDetails$ = this.courtEventInfoFacade.courtBookingDetails$;
    club$ = this.coreFacade.selectedClub$;

    public courtBookingId: string;

    private subscriptions: Subscription = new Subscription();

    constructor(
        private courtEventInfoFacade: CourtEventInfoFacade,
        private coreFacade: CoreFacade,
        private cancelModalLauncher: CancelCourtEventLauncherService,
        private courtEventNoteSaveLauncherService: CourtEventNoteSaveLauncherService,
        private actions$: Actions,
        private readonly modalRef: BsModalRef
    ) { }

    ngOnInit(): void {
        this.courtEventInfoFacade.loadCourtBookingDetails(this.courtBookingId);

        this.subscriptions.add(
            this.actions$.pipe(ofActionSuccessful(SaveCourtEventNoteSuccessAction)).subscribe(() => {
                this.courtEventInfoFacade.loadCourtBookingDetails(this.courtBookingId);
            })
        );
    }

    ngOnDestroy(): void {
        this.courtEventInfoFacade.clearLoadedCourtBooking();

        this.subscriptions.unsubscribe();
    }

    close(): void {
        this.modalRef.hide();
    }

    cancel(): void {
        this.cancelModalLauncher.openCancelCourtBookingModal(
            this.courtBookingId,
            () => this.courtEventInfoFacade.loadCourtBookingDetails(this.courtBookingId));
    }

    details(): void {
        this.courtEventInfoFacade.goToCourtBookingDetails(this.courtBookingId);
        this.close();
    }

    noShowAll(): void {
        this.courtEventInfoFacade.noShowAllPlayers(this.courtBookingId);
    }

    checkInAll(): void {
        this.courtEventInfoFacade.checkInAllPlayers(this.courtBookingId);
    }

    onPlayerChanged() {
        this.courtEventInfoFacade.loadCourtBookingDetails(this.courtBookingId);
    }

    onAddNote(): void {
        this.courtEventNoteSaveLauncherService.openCourtNoteSave({ courtEventId: this.courtBookingId });
    }

    public isCancellationAvailable(courtBooking: CourtBookingInfoModel) {
        return courtBooking.isCancellationAvailable;
    }

    public isNoShowAvailable(courtBooking: CourtBookingInfoModel) {
        return courtBooking.isNoShowAllAvailable;
    }

    public isCheckInAvailable(courtBooking: CourtBookingInfoModel) {
        return courtBooking.isCheckInAllAvailable;
    }

    public isAnyNote(courtBooking: CourtBookingInfoModel): boolean {
        return courtBooking.notes?.length > 0;
    }
}
